import { Box, Typography } from "@material-ui/core";
import React from "react";
import {
  DateTimeInput,
  ImageField,
  ImageInput,
  regex,
  required,
  TextInput,
  SelectInput,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";

const DescriptionTabForm = (props) => {

  const validateRequired = [required()];
  const urlValidate = [
    regex(
      /^((http[s]?|ftp):\/)?\/?([^:\/\s]+)((\/\w+)*\/)([\w\-\.]+[^#?\s]+)(.*)?(#[\w\-]+)?$/,
      "invalid url",
    ),
  ];

  const sexTypes = [
    { id: "none", name: "None" },
    { id: "male", name: "Male" },
    { id: "female", name: "Female" },
  ];

  const prizeTypes = [
    { name: "Dream Home", id: "dreamHome" },
    { name: "Early Bird", id: "earlyBird" },
    { name: "Week Draws", id: "weekDraws" },
  ];

  return (
    <Box>
      <Box
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          padding: "10px 10px",
        }}
      >
        <Box width={{ md: "100%", lg: "60%" }}>
          <div className="winner-form-row">
            <Box width={{ md: "100%", lg: "50%" }}>
              <Typography>Winner name</Typography>
              <TextInput
                className="input-form"
                source="name"
                fullWidth
                options={{ label: "name" }}
                disabled={props.disabledInputs}
              />
            </Box>
            <Box width={{ md: "100%", lg: "50%" }}>
              <Typography>Sex</Typography>
              <SelectInput source="sex" choices={sexTypes} disabled={props.disabledInputs}/>
            </Box>
          </div>
          <div className="winner-form-row">
            <Box width={{ md: "100%", lg: "50%" }}>
              <Typography gutterBottom className="base-color">
                Draw date
              </Typography>
              <DateTimeInput
                className="input-form"
                label=""
                source="drawDate"
                validate={validateRequired}
                disabled={props.disabledInputs}
              />
            </Box>
            <Box width={{ md: "100%", lg: "50%" }}>
              <Typography>Prize type</Typography>
              <SelectInput source="prizeType" choices={prizeTypes} disabled={props.disabledInputs}/>
            </Box>
          </div>
          <div className="winner-form-row">
            <Box width={{ md: "100%", lg: "50%" }}>
              <Typography>Pize title</Typography>
              <TextInput
                className="input-form"
                source="prizeTitle"
                fullWidth
                options={{ label: "prize" }}
                disabled={props.disabledInputs}
              />
            </Box>
            <Box width={{ md: "100%", lg: "50%" }}>
              <Typography>Prize label</Typography>
              <TextInput
                className="input-form"
                source="prizeLabel"
                fullWidth
                options={{ label: "label" }}
                disabled={props.disabledInputs}
              />
            </Box>
          </div>
          <Box width={{ md: "100%", lg: "100%" }}>
            <Typography>Ticket number</Typography>
            <TextInput
              className="input-form"
              source="ticket"
              fullWidth
              options={{ label: "ticket" }}
              disabled={props.disabledInputs}
            />
          </Box>
          <Box display="flex" position="relative" className="text-parent">
            <RichTextInput
              className="input-form"
              source="description"
              disabled={props.disabledInputs}
            />
          </Box>
        </Box>
        <Box width={{ md: "100%", lg: "37%" }}>
          <ImageInput
            label="Prize Photo Url"
            multiple={false}
            source="photoUrl"
            className="base-color image-field"
            disabled={props.disabledInputs}
            // maxSize={500000}
          >
            <ImageField source="src" title="title" />
          </ImageInput>

          <ImageInput
            label="Winner Photo Url"
            multiple={false}
            source="winnerPhotoUrl"
            className="base-color image-field"
            disabled={props.disabledInputs}
            // maxSize={500000}
          >
            <ImageField source="src" title="title" />
          </ImageInput>

          {/* <Box marginTop="2em">
            <Typography variant="subtitle1" gutterBottom className="base-color">
              Video
            </Typography>
            <Typography variant="caption" gutterBottom className="base-color">
              Add video url
            </Typography>
            <TextInput
              source="videoUrl"
              fullWidth
              className="input-form"
              label=""
              disabled={props.disabledInputs}
              validate={urlValidate}
            />
          </Box> */}
        </Box>
      </Box>
    </Box>
  );
};
export default DescriptionTabForm;
